"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var confirmation_button_box_module_scss_1 = __importDefault(require("./confirmation-button-box.module.scss"));

var custom_modal_button_component_1 = __importDefault(require("../custom-modal/custom-modal-button.component"));

var DEFAULT_CANCEL_TEXT = 'キャンセル';
var DEFAULT_CONFIRM_TEXT = '確認';

var ConfirmationButtonBox = function ConfirmationButtonBox(_ref) {
  var onCancelClick = _ref.onCancelClick,
      onConfirmClick = _ref.onConfirmClick,
      _ref$cacelText = _ref.cacelText,
      cacelText = _ref$cacelText === void 0 ? DEFAULT_CANCEL_TEXT : _ref$cacelText,
      _ref$confirmText = _ref.confirmText,
      confirmText = _ref$confirmText === void 0 ? DEFAULT_CONFIRM_TEXT : _ref$confirmText;
  return react_1.default.createElement("div", {
    className: confirmation_button_box_module_scss_1.default.buttonBox
  }, react_1.default.createElement(custom_modal_button_component_1.default, {
    color: "secondary",
    onClick: onCancelClick
  }, cacelText), react_1.default.createElement(custom_modal_button_component_1.default, {
    color: "primary",
    onClick: onConfirmClick
  }, confirmText));
};

exports.default = ConfirmationButtonBox;